import { LICENSE_RENEWAL_SERVICE } from 'dashboard/components/dashboard-widget/license-renewal/license-renewal-widget-component';
import template from './privilege-item.html';

const mapStateToThis = ({ dictionary, session }) => {
  const { privilegeDisplayTypes } = dictionary;
  const { isAdmin } = session;

  return {
    privilegeDisplayTypes,
    isAdmin,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class PrivilegeItemController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getName() {
    return this.privilegeDisplayTypes[this.privilegeKey] ? this.privilegeDisplayTypes[this.privilegeKey].value : this.privilegeKey;
  }

  showOnlineLicensingServicesTooltip() {
    return !this.isAdmin && this.privilege.name === LICENSE_RENEWAL_SERVICE;
  }
}

export default class PrivilegeItemComponent {
  constructor() {
    this.controller = PrivilegeItemController;
    this.template = template;
    this.bindings = {
      privilege: '<',
      privilegeKey: '<',
      parents: '<',
      root: '<',
      onToggle: '&',
      isEditable: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-item/privilege-item-component.js